export default __webpack_public_path__ + "static/media/tennis_icon.6d2f3c08.png";